import React, { useCallback } from 'react';
import { getIn } from 'formik';

import Checkbox from '../../checkbox';
import { FieldElementPropTypes } from '../propTypes';

const CheckboxField = ({
  field: { id, name, label, mode, value, optional, onChange: customOnChange, ...props },
  ctx: { setFieldValue, setFieldTouched, touched, errors, classes }
}) => {
  const onChange = useCallback(
    (e) => {
      const checked = e.target.checked;
      setFieldValue(name || id, checked);
      setFieldTouched(id, true, false);
      if (customOnChange) {
        customOnChange(e, checked);
      }
    },
    [setFieldTouched, setFieldValue, id, name]
  );
  return (
    <Checkbox
      key={id}
      id={id}
      name={name || id}
      value={!!value}
      mode={mode}
      label={label}
      classes={classes[id]}
      onChange={onChange}
      error={getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={getIn(touched, name || id) ? getIn(errors, name || id) : undefined}
      {...props}
    />
  );
};

CheckboxField.propTypes = FieldElementPropTypes;

export default CheckboxField;
